import { useTranslation } from 'react-i18next';
import { Headset } from 'lucide-react';
import { PLAN_FEATURES } from '@scio3/shared-types';
import { useAuthStore } from '@/stores/auth-store';
import { isFreeEmail } from '@/features/survey/utils/free-email-domains';
import { SUPPORT_PHONE_TEL, SUPPORT_EMAIL } from '../utils/constants';

const PHONE_SUPPORT_PLANS: Set<string> = new Set([
  PLAN_FEATURES.PRO,
  PLAN_FEATURES.PRO_PLUS,
  PLAN_FEATURES.ENGAGE,
  PLAN_FEATURES.ENTERPRISE,
]);

/** Contact-support info — headset icon + phone/email/hours. */
export function SupportInfo() {
  const { t } = useTranslation();
  const planFeature = useAuthStore((s) => s.company?.payment?.planFeature ?? 'free');
  const email = useAuthStore((s) => s.me?.email ?? '');
  const showPhone = PHONE_SUPPORT_PLANS.has(planFeature) && !isFreeEmail(email);

  return (
    <div className="flex items-start gap-2.5">
      <Headset className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
      <div className="min-w-0 space-y-0.5 text-xs leading-snug">
        <p className="font-medium text-foreground">
          {t('optibot.contactSupport')}
          {showPhone && (
            <>
              {' · '}
              <a href={`tel:${SUPPORT_PHONE_TEL}`} className="text-primary hover:underline">
                {t('optibot.supportPhone')}
              </a>
            </>
          )}
        </p>
        <p className="text-muted-foreground">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline">
            {t('optibot.supportEmail')}
          </a>
          {' · '}
          {t('optibot.supportHours')}
        </p>
      </div>
    </div>
  );
}
